import React, { useState } from 'react';
import { Grid, Typography, Button, IconButton } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Modal from '@mui/material/Modal';
import {
  COLOR_PRIMARY,
  COLOR_PRIMARY_DARK,
  COLOR_PRIMARY_LIGHT,
  DARK_GREY,
  BACKGROUND_COLOR,
} from 'src/const';
import { CircularProgress } from '@mui/material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: BACKGROUND_COLOR,
      boxShadow: `inset 0px 5px 10px 0px ${DARK_GREY}`,
    },
    warningModal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 999999,
      backgroundColor: BACKGROUND_COLOR,
      padding: theme.spacing(4),
      borderRadius: 10,
      [theme.breakpoints.up('xs')]: {
        maxWidth: 600,
      },
    },
    customButton: {
      background: COLOR_PRIMARY_DARK,
      borderRadius: 5,
      border: 70,
      color: 'white',
      height: 45,
      padding: '0 15px',
      boxShadow: '0 1px 1px 1px rgba(255, 255, 255, .3)',
      '&:hover': {
        background: COLOR_PRIMARY_LIGHT,
      },
    },
    customButtonReversed: {
      background: BACKGROUND_COLOR,
      borderRadius: 5,
      border: 70,
      color: COLOR_PRIMARY_DARK,
      height: 45,
      padding: '0 15px',
      boxShadow: '0 1px 1px 1px rgba(255, 255, 255, .3)',
      '&:hover': {
        background: COLOR_PRIMARY_LIGHT,
      },
    },
    creditsText: {
      color: COLOR_PRIMARY,
      fontSize: '1rem',
      cursor: 'pointer',
    },
    iconButton: {
      padding: 3,
    },
    addCreditsBtn: {
      fontSize: 20,
      color: COLOR_PRIMARY_DARK,
      display: 'inline-block',
      marginBottom: '3px',
    },
    loaderScreen: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#fff',
      zIndex: 999,
      borderRadius: 20,
    },
  })
);

const ConfirmUnlockRegionModal = ({
  open,
  onConfirm,
  onCancel,
  message,
  buttonNames,
  _onClose,
  reverseButton,
  showLoader,
}: {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  message: string;
  buttonNames?: [string, string];
  _onClose?: () => void;
  reverseButton?: boolean;
  showLoader?: boolean;
}) => {
  const classes = useStyles();

  const [showLoading, setShowLoading] = useState<boolean>(false);

  const handleClose = () => {
    _onClose && _onClose();
  };

  const LoadingScreen = () => {
    return (
      <div className={classes.loaderScreen}>
        <CircularProgress />
      </div>
    );
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center">
        <div className={`${classes.warningModal} modal-custom`}>
          {showLoading && <LoadingScreen />}

          <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="center"
            style={{ marginBottom: 30 }}
          >
            <Typography variant="subtitle1">{message}</Typography>
          </Grid>

          <Grid
            container
            direction={reverseButton ? 'row-reverse' : 'row'}
            justifyContent="space-evenly"
            alignItems="center"
          >
            <Button className={classes.customButtonReversed} onClick={onCancel}>
              {buttonNames ? buttonNames[0] : 'Cancel'}
            </Button>
            <Button
              className={classes.customButton}
              onClick={() => {
                showLoader && setShowLoading(true);
                onConfirm();
              }}
            >
              {buttonNames ? buttonNames[1] : 'Confirm'}
            </Button>
          </Grid>
        </div>
      </Grid>
    </Modal>
  );
};

export default ConfirmUnlockRegionModal;
